import { useEffect, useState } from 'react'
import { Flex, Spin } from 'antd'
import LoyaltyTier from '../../components/loyaltyTier/LoyaltyTier'
import { LoyaltyTierReferralRule } from '../../models/LoyaltyTier'
import { fetchLoyaltyTiersReferralRules } from '../../services/LoyaltyTiersService'
import { Permission } from '../../utils/permissions'
import Page from '../../components/Page/Page'

const ReferralPage = () => {
  const [loyaltyTierReferralRules, setLoyaltyTierReferralRules] = useState<
    LoyaltyTierReferralRule[]
  >([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    setIsLoading(true)
    fetchLoyaltyTiersReferralRules()
      .then((rules) => setLoyaltyTierReferralRules(rules))
      .finally(() => setIsLoading(false))
  }, [])

  return (
    <Page
      permissions={Permission.listReferral}
      pageTitle={{
        title: 'Referral settings',
        level: 4,
        toolbar: isLoading && <Spin />,
      }}
    >
      <Flex vertical gap={24}>
        {loyaltyTierReferralRules.map((loyaltyTierReferralRule) => (
          <LoyaltyTier.ReferralCard
            key={loyaltyTierReferralRule.id}
            loyaltyTier={loyaltyTierReferralRule.loyaltyTier}
            giveLoyaltyTier={loyaltyTierReferralRule.giveLoyaltyTier}
          />
        ))}
      </Flex>
    </Page>
  )
}

export default ReferralPage
